// extracted by mini-css-extract-plugin
export default {"selfRateModal":"styles__selfRateModal___e2_qF","modalContent":"styles__modalContent___R6c1R","nextButtons":"styles__nextButtons___w0QOs"};